export function toJsonLdScript(field: unknown): string | null {
  const raw = readFieldValue(field);
  if (typeof raw !== 'string') return null;

  const json = unwrapScript(raw).trim();
  if (!json || json === '$name') return null;

  try {
    const parsed: unknown = JSON.parse(json);
    if (!parsed || typeof parsed !== 'object') return null;
    return JSON.stringify(parsed).replace(/</g, '\\u003c');
  } catch {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        'SchemaText is present but is not valid JSON-LD. Structured data was not rendered.'
      );
    }
    return null;
  }
}

export function readSchemaField(
  fields: Record<string, unknown> | null | undefined
): unknown {
  if (!fields) return undefined;

  if (Object.prototype.hasOwnProperty.call(fields, 'SchemaText'))
    return fields.SchemaText;
  if (Object.prototype.hasOwnProperty.call(fields, 'schemaText'))
    return fields.schemaText;

  const key = Object.keys(fields).find(
    name => name.replace(/\s+/g, '').toLowerCase() === 'schematext'
  );
  return key ? fields[key] : undefined;
}

function readFieldValue(field: unknown): unknown {
  if (field == null) return undefined;
  if (typeof field === 'object' && 'value' in field) {
    return (field as { value?: unknown }).value;
  }
  return field;
}

function unwrapScript(value: string): string {
  const match = value.trim().match(/^<script\b[^>]*>([\s\S]*?)<\/script>\s*$/i);
  return match ? match[1] : value;
}
